// extracted by mini-css-extract-plugin
export var chevron = "_h2-2";
export var dropdownItems = "_h2-0";
export var item = "_h2-1";